import * as React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "./dialog";
import { Button } from "./button";

export interface CustomModalProps {
  open: boolean;
  title?: string;
  description?: string;
  onClose: () => void;
  children?: React.ReactNode;
  footer?: React.ReactNode;
}

export function CustomModal({ open, title, description, onClose, children, footer }: CustomModalProps) {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent>
        {title && (
          <DialogHeader>
            <DialogTitle>{title}</DialogTitle>
          </DialogHeader>
        )}
        {description && <div className="text-muted-foreground mb-4">{description}</div>}
        {children}
        <Button className="align-self-end" onClick={onClose}>OK</Button>
        {footer && <DialogFooter>{footer}</DialogFooter>}
      </DialogContent>
    </Dialog>
  );
}
